import Vue from 'vue'
import VueRouter from 'vue-router'


import DashboardPage from "../pages/DashboardPage";
import UserList from "../pages/Users/UserList";
import UserDetails from "../pages/Users/UserDetails";
import Forbidden from "../pages/Forbidden";
import Projects from "../pages/Administration/Projects";
import LdapSync from "../pages/Administration/LdapSync";

//import Roles from "../pages/Administration/Roles";
import ProjectDetails from "../pages/Administration/ProjectDetails";
import DashboardPageDetail from "../pages/DashboardPageDetail";
import SingleSignOnRouter from "../components/ui/SingleSignOnRouter";
import FlycoLogin from "../pages/Auth/FlycoLogin";
import TursysLogin from "../pages/Auth/TursysLogin";
import CmsLogin from "../pages/Auth/CmsLogin";

import ManageMyProjects from "../pages/Manage/ManageMyProject";
import UserProject from "../pages/Administration/UserProject";
import UserRole from "../pages/Administration/UserRole";
import RolePermissions from "../pages/Administration/RolePermissions";
import Resources from "../pages/Administration/Resources";

import TokenService from "../services/token.service";
import AuthService from "../services/auth.service";


Vue.use(VueRouter);

/**
 * Route meta:
 * - public
 * - requiresLogout
 */

const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({y: 0}),
    routes: [

        {
            name: 'Dashboard',
            path: '/DashboardPage',
            component: DashboardPage,

        },
        {
            name: 'DashboardDetail',
            path: '/DashboardPageDetail/:projectId',
            component: DashboardPageDetail,

        },
        {
            name: 'SingleSignOnRouter',
            path: '/SingleSignOnRouter/:selectedProject',
            component: SingleSignOnRouter,
            meta: {
                public: true
            }
        },
        {
            name: 'Users',
            path: '/users',
            component: UserList,

        },
        {
            name: 'UserDetails',
            path: '/userdetails/:selectedUserId',
            component: UserDetails,

        },



        {
            name: 'FlycoLogin',
            path: '/flycologin',
            component: FlycoLogin
        },
        {
            name: 'CmsLogin',
            path: '/cmsLogin',
            component: CmsLogin
        },

        {
            name: 'TursysLogin',
            path: '/tursyslogin',
            component: TursysLogin
        },

        {
            name: 'Login',
            path: '/login/:selectedProject?\',',
            component: () => import('@/pages/Auth/Login'),
            meta: {
                public: true
            }

        },
        {
            name: 'Projects',
            path: '/projects',
            component: Projects,

        },
        {
            name: 'ProjectDetails',
            path: '/projectdetails/:selectedProjectId/:selectedProjectCode',
            component: ProjectDetails,

        },
        /*
        {
            name: 'Roles',
            path: '/roles',
            component: Roles,

        },*/
        {
            name: 'LdapSync',
            path: '/ldapsync',
            component: LdapSync,

        },
        {
            name: 'UserProject',
            path: '/userproject',
            component: UserProject,

        },
        {
            name: 'UserRole',
            path: '/userrole',
            component: UserRole,

        },
        {
            name: 'RolePermissions',
            path: '/rolepermissions',
            component: RolePermissions,

        },
        {
            name: 'Resources',
            path: '/resources',
            component: Resources,

        },
        {
            name: 'ManageMyProject',
            path: '/manageMyProject',
            component: ManageMyProjects,

        },
        {
            path: "/",
            redirect: "/DashboardPage",

        },
        {
            name: "Forbidden",
            path: "/403",
            component: Forbidden
        }
    ]
});

router.beforeEach((to, from, next) => {
    const isPublic = to.matched.some(r => r.meta.public);
    const requiresLogout = to.matched.some(r => r.meta.requiresLogout);
    const requiredPermission = to.matched[0].meta.requiredPermission;

    const isAuthenticated = !!TokenService.getAccessToken();

    if (!isAuthenticated && !isPublic) {
        return next({
            name: 'Login',
            query: {redirect: to.fullPath}
        });
    }

    if (isAuthenticated && requiresLogout) {
        return next('/');
    }

    if (requiredPermission && !AuthService.hasPermission(requiredPermission)) {
        return next('/403');
    }

    next();
});

//loading start//
router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) {
        // Start the route progress bar.
        // eslint-disable-next-line no-undef
        NProgress.start()
    }
    next()
});
// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
    // Complete the animation of the route progress bar.
    // eslint-disable-next-line no-undef
    NProgress.done()
});
//loading end//

export default router
